import { makeStyles } from "@material-ui/core/styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import PropTypes from "prop-types";
import React, { useState } from "react";

import PageBody from "@components/PageBody";
import Report from "@components/Report";
import settings from "@settings/index";
import AdminPageTemplate from "@templates/AdminPage";

const useStyles = makeStyles(() => ({
  reportPageSelector: {
    marginTop: "8px",
  },
  reportPageContainer: {
    marginTop: "32px",
  },
}));

const ReportPageEnum = {
  BY_USER: "by_user",
  BY_SHORTCODE: "by_shortcode",
};

const DEFAULT_REPORT_PAGE = ReportPageEnum.BY_USER;

function MessageSent(props) {
  const classes = useStyles();

  const [reportPage, setReportPage] = useState(DEFAULT_REPORT_PAGE);

  return (
    <AdminPageTemplate breadcrumbs={props.breadcrumbs}>
      <PageBody title="Mensagens Enviadas">
        <div className={classes.reportPageSelector}>
          <ToggleButtonGroup
            value={reportPage}
            exclusive
            onChange={(e, value) => setReportPage(value)}
          >
            <ToggleButton value={ReportPageEnum.BY_USER}>Usuário</ToggleButton>
            <ToggleButton value={ReportPageEnum.BY_SHORTCODE}>
              Shortcode
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className={classes.reportPageContainer}>
          {reportPage === ReportPageEnum.BY_USER && (
            <Report quickSightID={settings.reports.MESSAGES_SENT_BY_USER} />
          )}

          {reportPage === ReportPageEnum.BY_SHORTCODE && (
            <Report
              quickSightID={settings.reports.MESSAGES_SENT_BY_SHORTCODE}
            />
          )}
        </div>
      </PageBody>
    </AdminPageTemplate>
  );
}

MessageSent.propTypes = {
  breadcrumbs: PropTypes.array,
};

MessageSent.defaultProps = {
  breadcrumbs: [],
};

export default MessageSent;
